<template>
    <div class="cutdown">
        <span class="cd-text">剩余时间</span>
        <span v-if="hundred" class="cd-time">{{hundred}}</span>
        <span class="cd-time" >{{ten}}</span>
        <span class="cd-time" >{{bit}}</span>
        <span class="cd-text">:</span>
        <span class="cd-time">{{sec1}}</span>
        <span class="cd-time">{{sec2}}</span>
    </div>
</template>
<script>
export default {
    created(){
        this.startTime = new Date(this.start)
        this.endTime = new Date(this.end)
    },
    mounted(){
        
    },
    props:{
        start:{
            type: String,
            default: null
        },
        end:{
            type: String,
            default: null
        }
    },
    watch:{
        start(val){
            this.startTime = new Date(this.start)
            console.log("cutDown startTime:"+this.startTime)
        },
        end(val){
            this.endTime = new Date(this.end)
            console.log("cutDown endTime:"+this.endTime)
            this.initCutDown()
        }
    },
    data(){
        return {
            startTime: null,
            endTime: null,
            hundred:9,
            ten: 9,
            bit: 9,
            sec1: 9,
            sec2: 9,
            cutDownManger: null
        }
    },
    methods:{
        initCutDown(){
            let end = setInterval(() => {
            
            }, 3000);
            for(var i = 0;i<=end;i++){
                clearInterval(i);
            }
            this.cutDownManger = setInterval(this.cutDown,1000)  
        },
        cutDown(){
            let now = new Date()
            // console.log(this.cutDownManger)
            if( this.endTime.getTime()>now.getTime()&&this.startTime.getTime()<=now.getTime()){                
               let remaind = this.endTime.getTime() - now.getTime()               
               let seconds = Math.floor(remaind/1000)
               let sec = seconds%60
               let minutes =Math.floor(seconds/60)              
               this.sec2 = sec%10
               this.sec1 = (sec - this.sec2)%100/10
               this.bit = minutes%10;
               this.ten =Math.floor( minutes %100/10)
               this.hundred =Math.floor( minutes %1000/100)
            }else if(this.endTime.getTime()<=now.getTime()) {
                this.hundred = 0
                this.ten = 0
                this.bit =0
                this.sec1 = 0
                this.sec2 = 0
                this.stop()
            }
        },
        stop(){
            clearInterval(this.cutDownManger)
        }
    }    
}
</script>
<style scoped>
.cutdown{
    display: inline-block;
    position: relative;
    max-width: 15rem;
}
.cd-text{
    color: white;
    font-weight: bolder;
}
.cd-time{
    display: inline-block;
    background-color: white;
    color: black;
    padding: 3px;
    border-radius: 5px;
    font-weight: bold;
    padding-left: .5rem;
    padding-right: .5rem;
}
</style>


// WEBPACK FOOTER //
// src/views/system/cutdown.vue